(() => {
  const closeHoverOpenedMenus = () => {
    document.querySelectorAll('#header-component .header-menu details[open]').forEach((details) => {
      if (!details.matches(':focus-within')) details.removeAttribute('open');
    });
  };

  document.addEventListener('pointerover', (event) => {
    if (event.target.closest('#header-component .header-menu')) {
      window.requestAnimationFrame(closeHoverOpenedMenus);
    }
  }, { passive: true });
})();
